<template>
  <layout>
    <template v-slot:header>
      <h4>{{ topCount }} คอร์สเรียนยอดนิยมสูงสุด</h4>
    </template>
    <template v-slot:body>
      <bar-chart
        :chart-data="chartData"
        :options="options"
        :height="350"
      ></bar-chart>
      <div style="text-align: center" v-if="topCourses.length == 0">
        ไม่มีข้อมูล
      </div>
    </template>
  </layout>
</template>

<script>
import layout from "@/components/pages/analytics/shared/Layout";
import BarChart from "@/components/charts/BarChart.js";
import api from "@/services/api.js";

const BAR_COLOR = "#FFA503";
const BAR_HOVER_COLOR = "#E69500";

export default {
  components: {
    layout,
    BarChart
  },
  props: {
    apiRoute: { type: String, required: true },
    labelField: { type: String, default: "c_courseCode" },
    nameField: { type: String, default: "c_name" },
    valueField: { type: String, default: "activeStudent" },
    topCount: { type: Number, default: 10 }
  },
  data() {
    return {
      topCourses: [],
      chartData: {},
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        plugins: {
          datalabels: { display: false }
        },
        tooltips: {
          backgroundColor: "#000",
          titleFontColor: "#FFF",
          bodyFontColor: "#FFF",
          titleFontFamily: "Prompt, sans-serif",
          bodyFontFamily: "Prompt, sans-serif",
          displayColors: false,
          callbacks: {
            // Tooltip line 1
            title: tooltipItems => {
              const course = this.topCourses[tooltipItems[0].index];
              const code = course[this.labelField] || "";
              return (code + " " + course[this.nameField]).trim();
            },
            // Tooltip line 2
            label: tooltipItem => {
              return "จำนวนผู้เรียนที่เรียนอยู่: " + tooltipItem.yLabel + " คน";
            }
          }
        },
        scales: {
          xAxes: [
            {
              gridLines: { display: false },
              scaleLabel: {
                display: true,
                labelString: "คอร์สเรียน",
                fontFamily: "Prompt, sans-serif"
              }
            }
          ],
          yAxes: [
            {
              gridLines: { display: true, drawBorder: true },
              scaleLabel: {
                display: true,
                labelString: "จำนวนนักเรียน (คน)",
                fontFamily: "Prompt, sans-serif"
              },
              ticks: {
                beginAtZero: true,
                stepSize: 50
              }
            }
          ]
        }
      }
    };
  },
  methods: {
    async fetchTopCourses() {
      const res = await api.get(this.apiRoute);
      const courses = res.data || [];
      // Sort courses by enrollment
      this.topCourses = courses
        .slice()
        .sort((a, b) => Number(b[this.valueField]) - Number(a[this.valueField]))
        .slice(0, this.topCount);
      this.chartData = {
        labels: this.topCourses.map(course => course[this.labelField] || "-"),
        datasets: [
          {
            data: this.topCourses.map(
              course => Number(course[this.valueField]) || 0
            ),
            backgroundColor: BAR_COLOR,
            hoverBackgroundColor: BAR_HOVER_COLOR
          }
        ]
      };
    }
  },
  mounted() {
    this.fetchTopCourses();
  }
};
</script>

<style scoped>
h4 {
  font-family: "Prompt", sans-serif;
}
</style>
